import React, { useEffect } from 'react';
import { interpolateString } from '@utils/string';
import { useOrganization } from '@hooks/useOrganization';
import {
  ORGANIZATION_PLAN_INFO,
  USAGE_METRIC_MAP,
  USAGE_METRICS_ORDERED_KEYS,
} from '@constants/metering';
import useUsageDateRange from '@pages/metering/hooks/useUsageDateRange';
import styles from './meteringUsage.module.scss';
import UsageCard from '../../components/UsageCard';
import useMeteringUsage from '../../hooks/useMeteringUsage';

const MeteringUsage = () => {
  const { usageLimits, usageMetrics, fetchUsageMetrics } = useMeteringUsage();
  const { currentUsageCycleText, currentUsageCycleDays } = useUsageDateRange();
  const { currentOrganization } = useOrganization();
  type UsageMetricsKey = keyof typeof usageMetrics;

  useEffect(() => {
    fetchUsageMetrics();
  }, []);

  return (
    <div className={styles.container}>
      <UsageCard
        key="organization"
        label={ORGANIZATION_PLAN_INFO.label}
        metric={currentOrganization?.organizationName}
        limit={{
          current: currentUsageCycleDays.current ?? undefined,
          target: currentUsageCycleDays.target ?? undefined,
          name: interpolateString(ORGANIZATION_PLAN_INFO.limitLabel, {
            usageCycle: currentUsageCycleText,
          }) as string,
          targetLabel: currentUsageCycleDays.remaining
            ? (interpolateString(ORGANIZATION_PLAN_INFO.targetLabel, {
                days: currentUsageCycleDays.remaining,
              }) as string)
            : '',
        }}
      />
      {USAGE_METRICS_ORDERED_KEYS.map((keyName) => {
        const key = keyName as UsageMetricsKey;
        const metric = usageMetrics[key];
        const metricConsts = USAGE_METRIC_MAP[key];

        return (
          <UsageCard
            key={keyName}
            label={metricConsts.label}
            metric={metric}
            tooltip={metricConsts.tooltip}
            metricSuffix={metricConsts.metricUnit}
            limit={{
              current: metric,
              target: usageLimits?.[key] ?? undefined,
              name: metricConsts.limitLabel,
            }}
            showLimitInfo={!!usageLimits?.[key]}
          />
        );
      })}
    </div>
  );
};

export default MeteringUsage;
